// Formatting helpers for BR
export function formatCNPJ(cnpj) {
  if (!cnpj) return "";
  const c = cnpj.replace(/\D/g, "");
  if (c.length !== 14) return cnpj;
  return `${c.slice(0, 2)}.${c.slice(2, 5)}.${c.slice(5, 8)}/${c.slice(8, 12)}-${c.slice(12, 14)}`;
}

export function formatCurrency(value) {
  if (value == null || Number.isNaN(value)) return "R$ 0,00";
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
}

export function formatNumber(value) {
  if (value == null) return "0";
  return new Intl.NumberFormat("pt-BR").format(value);
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function relativeTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = Date.now() - d.getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "agora";
  if (mins < 60) return `há ${mins} min`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `há ${hrs}h`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `há ${days}d`;
  return formatDate(iso);
}

export const REGIME_LABELS = {
  simples_nacional: "Simples Nacional",
  lucro_presumido: "Lucro Presumido",
  lucro_real: "Lucro Real",
  mei: "MEI",
  imune: "Imune",
};

export const STATUS_LABELS = {
  regular: "Regular",
  atencao: "Atenção",
  risco: "Risco",
  critico: "Crítico",
};

export const SITUACAO_LABELS = {
  ativa: "Ativa",
  suspensa: "Suspensa",
  baixada: "Baixada",
  inapta: "Inapta",
};

export const ROLE_LABELS = {
  // Novos (v2.5+)
  platform_owner: "Platform Owner",
  commercial_master: "Administrador Comercial",
  commercial_consultant: "Consultor Comercial",
  company_admin: "Administrador do Escritório",
  manager: "Gerente",
  supervisor: "Supervisor",
  accountant: "Contador",
  fiscal_analyst: "Analista Fiscal",
  // Legado (retro-compat)
  administrador: "Administrador",
  socio: "Sócio",
  gerente: "Gerente",
  analista: "Analista",
  operador: "Operador",
};

export const HEALTH_LABELS = {
  excelente: "Excelente",
  bom: "Bom",
  atencao: "Atenção",
  critico: "Crítico",
};

export const UF_LIST = [
  "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA",
  "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN",
  "RS", "RO", "RR", "SC", "SP", "SE", "TO",
];
